import { useEffect } from "react";
import UsersTable from "./components/UsersTable";
import { Button } from "@mui/material";
import { useAppSelector } from "redux/hooks";
import { selectUsers } from "redux/slices/client";
import { useNavigate } from "react-router-dom";
import { AppRoutes } from "AppRoutes";

const PatternUsers = () => {
  const users = useAppSelector(selectUsers);
  const navigate = useNavigate();
  useEffect(() => {
    document.title = "Users";
  }, []);

  return (
    <div className="flex flex-col h-full">
      <div className="flex justify-between items-center">
        <p className="text-3xl font-bold">Pattern Users</p>
        <Button variant="contained" onClick={() => navigate(AppRoutes.usersAppInviteBuilder("pattern"))}>
          Invite Users
        </Button>
      </div>
      <UsersTable users={users} />
    </div>
  );
};

export default PatternUsers;
